module.exports = __webpack_public_path__ + "img/bg-logo.441b8c01.png";